module.exports = __webpack_public_path__ + "assets/img/PrizePool_btn.e3ca7bc0.png";